import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LibModule } from '../../../../ui-components/src/lib.module';
import { DashboardComponent } from './dashboard.component';
import { MatSortModule } from '@angular/material/sort';
import { MyAssessmentsComponent } from './my-assessments/my-assessments.component';
import { TeamAssessmentsComponent } from './team-assessments/team-assessments.component';

@NgModule({
  declarations: [
    DashboardComponent,
    MyAssessmentsComponent,
    TeamAssessmentsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatSortModule,
    LibModule
  ]
})
export class DashboardModule { }
